<template>
  <p
    v-bind="$attrs"
    class="text-justify text-base md:text-sm text-gray-600"
  >
    <slot />
  </p>
</template>
